import { render } from "./DealBene.vue?vue&type=template&id=06ed19f4&scoped=true"
import script from "./DealBene.vue?vue&type=script&lang=js"
export * from "./DealBene.vue?vue&type=script&lang=js"

import "./DealBene.vue?vue&type=style&index=0&id=06ed19f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ed19f4"]])

export default __exports__